import { createAction } from 'redux-actions';

export const getInvestmentHoldingsV2 = createAction('GET_INVESTMENT_HOLDINGS_V2');
export const getInvestmentHoldingsV2Success = createAction('GET_INVESTMENT_HOLDINGS_V2_SUCCESS');
export const getInvestmentHoldingsV2Failure = createAction('GET_INVESTMENT_HOLDINGS_V2_FAILURE');

export const createInvestmentHoldingV2 = createAction('CREATE_INVESTMENT_HOLDING_V2', (payload) => payload, (payload, meta) => meta);
export const createInvestmentHoldingV2Success = createAction('CREATE_INVESTMENT_HOLDING_V2_SUCCESS', (payload) => payload, (payload, meta) => meta);
export const createInvestmentHoldingV2Failure = createAction('CREATE_INVESTMENT_HOLDING_V2_FAILURE');

export const updateInvestmentHoldingV2 = createAction('UPDATE_INVESTMENT_HOLDING_V2', (payload) => payload, (payload, meta) => meta);
export const updateInvestmentHoldingV2Success = createAction('UPDATE_INVESTMENT_HOLDING_V2_SUCCESS');
export const updateInvestmentHoldingV2Failure = createAction('UPDATE_INVESTMENT_HOLDING_V2_FAILURE');

export const deleteInvestmentHoldingV2 = createAction('DELETE_INVESTMENT_HOLDING_V2', (payload) => payload, (payload, meta) => meta);
export const deleteInvestmentHoldingV2Success = createAction('DELETE_INVESTMENT_HOLDING_V2_SUCCESS');
export const deleteInvestmentHoldingV2Failure = createAction('DELETE_INVESTMENT_HOLDING_V2_FAILURE');
